import React from 'react'

const Arts = () => {
  return (
    <section
      className="my-20 px-32 flex justify-center items-center h-screen max-sm:px-8 max-sm:h-auto max-sm:my-32"
    >
      <h3 className='text-2xl max-sm:h-screen'>Arts coming soon!</h3>  
    </section>
  )
}

export default Arts